(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name dashboard.memberships.directive:receivedLeadsGraph
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="dashboard.memberships">
       <file name="index.html">
        <received-leads-graph></received-leads-graph>
       </file>
     </example>
   *
   */
  angular
    .module('dashboard.memberships')
    .directive('receivedLeadsGraph', receivedLeadsGraph);

  function receivedLeadsGraph() {
    return {
      restrict: 'EA',
      scope: {
        list: '=list'
      },
      templateUrl: 'dashboard/memberships/received-leads-graph-directive.tpl.html',
      replace: false,
      controllerAs: 'receivedLeadsGraph',
      controller: function ($scope, $filter) {
        var vm = this;

        vm.chartData = {
          labels: _.map($scope.list, function (day) {
            return $filter('date')(day.date, 'd/M');
          }),
          series: [_.map($scope.list, function (day) {
            return day.leads;
          })]
        };

        vm.chartOptions = {
          axisX: {
            showGrid: false,
            showLabel: false
          },
          axisY: {
            showGrid: true,
            showLabel: true,
            low: 0,
            onlyInteger: true
          },
          lineSmooth: false,
          scaleMinSpace: 10,
          height: 400
        };

        vm.chartEvents = {
          draw: function (data) {
            var circle;
            if (data.type === 'point') {
              circle = new Chartist.Svg('circle', {
                cx: [data.x],
                cy: [data.y],
                r: [5]
              }, 'ct-circle');
              data.element.replace(circle);
            }
          }
        };

        vm.responsiveOptions = [
          ['screen and (min-width: 768px) and (max-width: 991px)', {
            width: 646
          }],
          ['screen and (min-width: 992px) and (max-width: 1199px)', {
            width: 487
          }],
          ['screen and (min-width: 1200px)', {
            width: 590
          }]
        ];
      },
      link: function (scope, element, attrs, ctrl) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());
